<template>
    <b-modal :visible="showAdminModal === 'addUser'" size="lg" @hidden="hideModal" :lazy="true">
        <div slot="modal-title">
            <h4>Добавить пользователя</h4>
          <span class="small help-block">Перед добавлением пользователя создайте техцентр если он не существует</span>
        </div>
        <loading v-if="loading" :size="3" message="Загружаем..."></loading>
        <form v-else сlass="form-horizontal">
            <div class="form-group row" :class="{ 'has-danger': $v.userData.firstname.$error }">
                <label for="user-firstname" class="col-2 col-form-label">Имя</label>
                <div class="col-4">
                    <input class="form-control" type="text" id="user-firstname" v-model.trim="userData.firstname" @input="$v.userData.firstname.$touch()" autocomplete="off">
                    <span class="small help-block text-danger" v-if="$v.userData.firstname.$error">Имя обязательно должно быть указано, минимум {{$v.userData.lastname.$params.minLength.min}} символа</span>
                </div>
            </div>
            <div class="form-group row" :class="{ 'has-danger': $v.userData.lastname.$error }">
                <label for="user-lastname" class="col-2 col-form-label">Фамилия</label>
                <div class="col-4">
                    <input class="form-control" type="text" id="user-lastname" v-model.trim="userData.lastname" @input="$v.userData.lastname.$touch()" autocomplete="off">
                    <span class="small help-block text-danger" v-if="$v.userData.lastname.$error">Фамилия обязательно должна быть указана</span>
                </div>
            </div>
            <div class="form-group row" :class="{ 'has-danger': $v.userData.email.$error }">
                <label for="user-email" class="col-2 col-form-label">Электронная почта</label>
                <div class="col-4">
                    <input class="form-control" type="text" id="user-email" v-model.trim="userData.email" @input="$v.userData.email.$touch()" autocomplete="off">
                    <span class="small help-block text-danger" v-if="$v.userData.email.$error">Адрес электронной почты обязателен и должен быть валидным</span>
                </div>
                <div class="help-inline col-6">
                    <div class="row">
                        <div class="col-3">
                            <label class="switch switch-lg switch-3d switch-primary ml-1">
                                <input v-model="userData.notifyEmail" type="checkbox" class="switch-input">
                                <span class="switch-label"></span>
                                <span class="switch-handle"></span>
                                <small v-if="userData.notifyEmail">отправить</small>
                                <small v-else>не&nbsp;отправлять</small>
                            </label>
                        </div>
                        <div class="col-9">
                            <small class="text-muted">Отправить письмо с регистрационными данными</small>
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-group row" :class="{ 'has-danger': $v.userData.phone.$error }">
                <label for="user-phone" class="col-2 col-form-label">Номер телефона</label>
                <div class="col-4">
                    <div class="input-group">
                        <span class="input-group-addon">+7</span>
                        <input class="form-control" type="text" id="user-phone" v-model.trim="userData.phone" @input="$v.userData.phone.$touch()" autocomplete="off">
                    </div>
                    <span class="small help-block text-danger" v-if="$v.userData.phone.$error">Телефон обязателен и должен состоять из 10 цифр</span>
                </div>
            </div>
            <div class="form-group row" :class="{ 'has-danger': $v.userData.password.$error }">
                <label for="new-password" class="col-2 col-form-label">Пароль</label>
                <div class="col-4">
                    <div class="input-group">
                        <input class="form-control" :type="passwordType" id="new-password" @input="setPassword" :value="userData.password" autocomplete="off">
                        <span class="input-group-addon">
                            <i v-if="passwordType === 'password'" @click="passwordType = 'text'" class="fa fa-eye" aria-hidden="true"></i>
                            <i v-else class="fa fa-eye-slash" @click="passwordType = 'password'" aria-hidden="true"></i>
                        </span>
                    </div>
                    <span class="small help-block text-danger" v-if="$v.userData.password.$error">Пароль обязателен, минимум {{$v.userData.password.$params.minLength.min}} символов</span>
                </div>
                <div class="help-inline col-6">
                    <button @click.prevent="generatePassword" class="btn btn-secondary"><i class="fa fa-unlock-alt" aria-hidden="true"></i> Сгенерировать</button>
                </div>
            </div>
            <div class="form-group row">
                <label class="col-md-2 form-control-label">Компании</label>
                <div class="col-md-10">
                    <multiselect
                            v-model="userData.companies"
                            :options="additionalData.companies"
                            :searchable="true"
                            :close-on-select="false"
                            :show-labels="false"
                            :multiple="true"
                            placeholder="Компании не выбран"
                            track-by="id" label="name"
                    >
                    </multiselect>
                </div>
            </div>
            <div class="form-group row"  :class="{ 'has-danger': $v.userData.techcenters.$error }">
                <label class="col-md-2 form-control-label">Техцентры</label>
                <div class="col-md-10">
                    <multiselect
                            v-model="userData.techcenters"
                            :options="additionalData.techcenters"
                            :searchable="true"
                            :close-on-select="false"
                            :show-labels="false"
                            :multiple="true"
                            placeholder="Техцентры не выбран"
                            track-by="id" label="name"
                    >
                    </multiselect>
                    <span class="small help-block text-danger" v-if="$v.userData.techcenters.$error">Как минимум один техцентр должен быть выбран</span>
                </div>
            </div>
            <div class="form-group row"  :class="{ 'has-danger': $v.userData.roles.$error }">
                <label class="col-md-2 form-control-label">Роли пользователя</label>
                <div class="col-md-10">
                    <multiselect
                            v-model="userData.roles"
                            :options="additionalData.roles"
                            :searchable="true"
                            :close-on-select="false"
                            :show-labels="false"
                            :multiple="true"
                            placeholder="Роли не выбран"
                            track-by="id" label="description"
                    >
                    </multiselect>
                    <span class="small help-block text-danger" v-if="$v.userData.roles.$error">Роль должна быть указана</span>
                </div>
            </div>
        </form>
        <div slot="modal-footer">
            <button v-if="!loading" type="button" class="btn btn-success" @click.prevent="beforeUpdateForm">Добавить пользователя</button>
        </div>
    </b-modal>
</template>
<script>
  import { required, minLength, email, numeric, maxLength } from 'vuelidate/lib/validators'
  import getAdditionalDataForUserAddQuery from './../../gql/queries/getAdditionalDataForUserAdd.graphql'

  import addUserMutate from './../../gql/mutations/AddUser.graphql'
  import { mapState, mapActions } from 'vuex'
  import { ADD_TOAST_MESSAGE } from 'vuex-toast'
  import Multiselect from 'vue-multiselect'
  export default {
    computed: {
      ...mapState({
        showAdminModal: state => state.adminStore.showModal
      })
    },
    watch: {
      showAdminModal: function (val) {
        if (val === 'addUser') {
          this.loading = true
          this.$apollo.query({
            query: getAdditionalDataForUserAddQuery,
            variables: {
              all: true
            }
          }).then((result) => {
            this.loading = false
            this.additionalData = result.data
          })
          this.clearUserData()
        }
      }
    },
    data () {
      return {
        loading: false,
        passwordType: 'password',
        userData: {},
        additionalData: {
          techcenters: [],
          roles: [],
          companies: []
        }
      }
    },
    methods: {
      beforeUpdateForm () {
        this.$v.userData.$touch()
        if (!this.$v.userData.$error) {
          this.addUser()
        }
      },
      /**
       * Добаление заказа
       */
      addUser () {
        this.loading = true
        this.$apollo.mutate({
          mutation: addUserMutate,
          variables: {
            firstname: this.userData.firstname,
            lastname: this.userData.lastname,
            email: this.userData.email,
            phone: this.userData.phone,
            password: this.userData.password,
            roles: this.getCollectionIds(this.userData.roles),
            techcenters: this.getCollectionIds(this.userData.techcenters),
            companies: this.getCollectionIds(this.userData.companies),
            notifyEmail: this.userData.notifyEmail
          }
        }).then((data) => {
          this.loading = false
          this.addToast({
            text: 'Пользователь успешно добавлен',
            type: 'success',
            dismissAfter: 3000
          })
          this.clearUserData()
          this.hideModal()
        }).catch((error) => {
          console.error(error)
          this.addToast({
            text: 'Произошла ошибка:' + error,
            type: 'danger',
            dismissAfter: 10000
          })
          this.loading = false
        })
      },
      getCollectionIds (collection) {
        return collection.map((item) => {
          return item.id
        })
      },
      hideModal () {
        this.$store.dispatch('setAdminModal', false)
      },
      ...mapActions({
        addToast: ADD_TOAST_MESSAGE
      }),
      setPassword (e) {
        this.userData.password = e.target.value
        this.$v.userData.password.$touch()
      },
      generatePassword () {
        this.userData.password = Math.random().toString(36).slice(-8)
        this.passwordType = 'text'
        this.$v.userData.password.$touch()
      },
      clearUserData () {
        this.userData = {
          firstname: '',
          lastname: '',
          email: '',
          phone: '',
          password: '',
          techcenters: [],
          companies: [],
          roles: [],
          notifyEmail: true
        }
        this.$v.userData.$reset()
      }
    },
    components: {
      Multiselect
    },
    validations: {
      userData: {
        lastname: {
          required,
          minLength: minLength(2)
        },
        firstname: {
          required,
          minLength: minLength(2)
        },
        email: {
          required,
          email
        },
        phone: {
          required,
          numeric,
          maxLength: maxLength(10),
          minLength: minLength(10)
        },
        password: {
          required,
          minLength: minLength(6)
        },
        roles: {
          required
        },
        techcenters: {
          required
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ModalAdminAddUser.vue?48bf4016